module.exports = __webpack_public_path__ + "img/3.611e7ae4.png";